"use client";

import { postApi } from "@src/config/apiWithAxios"
import { URL_POST_CONTACT } from "@src/constant/api-url"

export const postContact = async (payload) => {
  const res = await postApi(URL_POST_CONTACT, payload);

  return res?.data?.data
}
